import { Mask, type MaskInputOptions } from 'maska';
export const IP_MASK: MaskInputOptions = {
  mask: '#00.#00.#00.#00',
  tokens: {
    0: {
      pattern: /[0-9]/,
      optional: true,
    },
  },
};

export const MAC_MASK: MaskInputOptions = {
  mask: '00:00:00:00:00:00',
  tokens: {
    '0': {
      pattern: /[0-9A-Fa-f]/,
      transform: v => v.toUpperCase(),
    },
  },
};

export const PHONE_MASK: MaskInputOptions = {
  mask: '+1 (###) ###-####',
  tokens: {
    '#': {
      pattern: /[0-9]/,
    },
  },
};

const cdrPattern = /^\+1\d{10}$/;

const CDR_MASK: MaskInputOptions = {
  mask: (cdr: string) => (cdrPattern.test(cdr) ? '+1 (###) ###-####' : cdr),
};

export const threeDigitMask: MaskInputOptions = {
  mask: '###',
  tokens: {
    '#': {
      pattern: /[0-9]/,
    },
  },
};

export const phoneMask = new Mask(PHONE_MASK);
export const cdrMask = new Mask(CDR_MASK);
